/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedOnboardingUsers.defs'
export { main as default } from './getSuggestedOnboardingUsers.defs'
